import { render, staticRenderFns } from "./BrowseBook.vue?vue&type=template&id=7d498d3a&scoped=true&"
import script from "./BrowseBook.vue?vue&type=script&lang=js&"
export * from "./BrowseBook.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBook.vue?vue&type=style&index=0&id=7d498d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d498d3a",
  null
  
)

export default component.exports